const strings = {
    companyName: process.env.REACT_APP_COMPANY_NAME,
    companySlogan: process.env.REACT_APP_COMPANY_SLOGAN
}

export default strings